import { lazy } from 'react'

import { urlRoutes } from 'presentation/routes/config/urlRoutes/urlRoutes'

export const AvailableDestinationsByPackageRoutes = [
  {
    nameUrl: 'Destinos disponibles por paquete',
    path: urlRoutes.private.availablePackagesByDestinationId.url,
    element: lazy(() => import('presentation/pages/availablePackagesByDestination')),
    rols: ['*'],
  },
]
